import stringSimilarity from 'string-similarity'

/**
 * groupStringsBySimilarity uses Dice Coeffecients from string-similariy
 * library to group a list of strings into groups by match rate.
 * From: https://stackoverflow.com/questions/42213194/group-similar-strings-from-an-array-in-node-js
 */
export const groupStringsBySimilarity = (source, rate = 0.5) => {
  let x, y
  const _source = source.slice()
  const matches = []
  for (x = _source.length - 1; x >= 0; x--) {
    const output = _source.splice(x, 1)

    for (y = _source.length - 1; y >= 0; y--) {
      const match = stringSimilarity.compareTwoStrings(output[0], _source[y])
      if (match > rate) {
        output.push(_source[y])
        _source.splice(y, 1)
        x--
      }
    }
    matches.push(output)
  }
  return matches
}

export default groupStringsBySimilarity
